import { useState, useCallback } from 'react';

interface UseShopDetailCustomerReviewCardReturn {
  isExpanded: boolean;
  handleClickExpanded: () => void;
}

const useShopDetailCustomerReviewCard =
  (): UseShopDetailCustomerReviewCardReturn => {
    const [isExpanded, setIsExpanded] = useState(false);

    const handleClickExpanded = useCallback(() => {
      setIsExpanded((prev) => !prev);
    }, []);

    return {
      isExpanded,
      handleClickExpanded,
    };
  };

export default useShopDetailCustomerReviewCard;
